import { useState, useEffect } from 'react'
import { getVentesJournalieres, CONCESSIONS, MOIS_FR } from '../lib/supabase'
import './Dashboard.css'
import './Journal.css'

export default function Journal() {
  const now = new Date()
  const annee = now.getFullYear()
  const mois = now.getMonth() + 1

  const [moisSel, setMoisSel] = useState(mois)
  const [anneeSel, setAnneeSel] = useState(annee)
  const [donnees, setDonnees] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function load() {
      setLoading(true)
      try {
        const debut = `${anneeSel}-${String(moisSel).padStart(2,'0')}-01`
        const lastDay = new Date(anneeSel, moisSel, 0).getDate()
        const fin = `${anneeSel}-${String(moisSel).padStart(2,'0')}-${lastDay}`
        const data = await getVentesJournalieres(debut, fin)
        setDonnees(data)
      } catch (e) {
        console.error(e)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [moisSel, anneeSel])

  // Grouper par date
  const parDate = {}
  donnees.forEach(r => {
    if (!parDate[r.date]) parDate[r.date] = {}
    parDate[r.date][r.concession] = { neuf: r.neuf, occasion: r.occasion }
  })
  const dates = Object.keys(parDate).sort().reverse()

  // Totaux du mois
  const totNeuf = donnees.reduce((s, r) => s + r.neuf, 0)
  const totOcc  = donnees.reduce((s, r) => s + r.occasion, 0)

  const annees = [2024, 2025, 2026]
  const moisOptions = Array.from({length: 12}, (_, i) => i + 1)

  return (
    <div className="journal-page">
      <div className="page-header">
        <div>
          <h1>Journal des saisies</h1>
          <p>Toutes les entrées par jour et par concession</p>
        </div>
      </div>

      <div className="journal-controls">
        <select value={anneeSel} onChange={e => setAnneeSel(parseInt(e.target.value))}>
          {annees.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
        <select value={moisSel} onChange={e => setMoisSel(parseInt(e.target.value))}>
          {moisOptions.map(m => <option key={m} value={m}>{MOIS_FR[m]}</option>)}
        </select>
      </div>

      <div className="metrics-grid" style={{marginBottom:'1.5rem'}}>
        <div className="metric-card">
          <div className="metric-label">Neufs — {MOIS_FR[moisSel]}</div>
          <div className="metric-val">{totNeuf.toLocaleString('fr-CA')}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">Occasion — {MOIS_FR[moisSel]}</div>
          <div className="metric-val">{totOcc.toLocaleString('fr-CA')}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">Total — {MOIS_FR[moisSel]}</div>
          <div className="metric-val">{(totNeuf + totOcc).toLocaleString('fr-CA')}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">Jours saisis</div>
          <div className="metric-val">{dates.length}</div>
        </div>
      </div>

      {loading ? <div className="loading">Chargement…</div> : (
        <div className="table-wrap">
          <table className="journal-table">
            <thead>
              <tr>
                <th>Date</th>
                {CONCESSIONS.map(c => (
                  <th key={c.id} colSpan={2} className="conc-header">
{c.id === 'hyundai_blainville' ? 'Hyundai B.' : c.id === 'honda_blainville' ? 'Honda B.' : c.label.replace('Subaru ','').replace('Hyundai ','').replace('Honda ','')}                  </th>
                ))}
                <th colSpan={2}>Total</th>
              </tr>
              <tr className="subheader">
                <th></th>
                {CONCESSIONS.map(c => (
                  <>
                    <th key={c.id+'-n'} className="sub-n">N</th>
                    <th key={c.id+'-o'} className="sub-o">O</th>
                  </>
                ))}
                <th className="sub-n">N</th>
                <th className="sub-o">O</th>
              </tr>
            </thead>
            <tbody>
              {dates.map(date => {
                const d = parDate[date]
                const totN = CONCESSIONS.reduce((s,c) => s + (d[c.id]?.neuf || 0), 0)
                const totO = CONCESSIONS.reduce((s,c) => s + (d[c.id]?.occasion || 0), 0)
                const dateObj = new Date(date + 'T12:00:00')
                const dateFmt = dateObj.toLocaleDateString('fr-CA', {weekday:'short', day:'numeric', month:'short'})
                return (
                  <tr key={date}>
                    <td className="date-cell">{dateFmt}</td>
                    {CONCESSIONS.map(c => (
                      <>
                        <td key={c.id+'-n'} className={`num ${!d[c.id] ? 'missing' : ''}`}>
                          {d[c.id]?.neuf ?? '—'}
                        </td>
                        <td key={c.id+'-o'} className={`num ${!d[c.id] ? 'missing' : ''}`}>
                          {d[c.id]?.occasion ?? '—'}
                        </td>
                      </>
                    ))}
                    <td className="num bold">{totN}</td>
                    <td className="num bold">{totO}</td>
                  </tr>
                )
              })}
              <tr className="total-row">
                <td>Total</td>
                {CONCESSIONS.map(c => {
                  const n = donnees.filter(r => r.concession === c.id).reduce((s,r) => s+r.neuf, 0)
                  const o = donnees.filter(r => r.concession === c.id).reduce((s,r) => s+r.occasion, 0)
                  return (
                    <>
                      <td key={c.id+'-tn'} className="num">{n}</td>
                      <td key={c.id+'-to'} className="num">{o}</td>
                    </>
                  )
                })}
                <td className="num bold">{totNeuf}</td>
                <td className="num bold">{totOcc}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
} 
